import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppEnvironment {
  BASE_URL = signal<string>('http://localhost:5199');
  API_BASE_URL = signal<string>('http://localhost:5199/api');
  MEDIA_BASE_URL = signal<string>('http://localhost:5199');
}
